import { defineStore } from "pinia";
import type { Deposit } from "@/gen/api/v1/api_pb";
import {
  CreateDepositRequestSchema,
  ListDepositsRequestSchema,
} from "@/gen/api/v1/api_pb";
import { create } from "@bufbuild/protobuf";
import { depositService } from "@/services/deposit.service";

export interface DepositState {
  deposits: Deposit[];
  isLoading: boolean;
}

export const useDepositStore = defineStore("deposit", {
  state: (): DepositState => ({
    deposits: [],
    isLoading: false,
  }),
  actions: {
    async fetchDeposits() {
      this.isLoading = true;
      try {
        const response = await depositService.listDeposits(
          create(ListDepositsRequestSchema, {
            page: 1,
            pageSize: 10,
          }),
        );
        this.deposits = response.deposits;
      } catch (error) {
        console.error("Falha ao buscar deposits:", error);
      } finally {
        this.isLoading = false;
      }
    },
    async createDeposit(deposit: Deposit) {
      this.isLoading = true;
      try {
        return await depositService.createDeposit(
          create(CreateDepositRequestSchema, {
            deposit: {
              id: 1,
              userId: deposit.userId,
              amount: deposit.amount,
            },
          }),
        );
      } catch (error) {
        console.error("Falha ao criar deposit:", error);
      } finally {
        this.isLoading = false;
      }
    },
  },
});
